import _ from 'underscore';
import { Component } from 'react';
import styled from 'styled-components';
import { sanitizeUserInput } from '~/utils/sanitize-user-input';
import { ContentIcon } from '~/features/common';
import AssetPickerTypes from '../../components/common/asset-picker/asset-picker-types';
import LearningObjectIcon from '../../components/common/asset-picker/LearningObjectIcon';

export default class AdminQuickSearchResult extends Component {
  constructor(props) {
    super(props);
  }

  componentDidUpdate() {
    if (this.props.isActive) {
      this.activeItem?.scrollIntoView({
        // scrolls only if element is about to go off viewable list
        block: 'nearest',
      });
    }
  }

  render() {
    const { onSelect, handleFolderClick, searchResult, type } = this.props;
    const activeClass = this.props.isActive ? 'default-search-result--active' : '';

    const selectAction = type === AssetPickerTypes.FOLDER ? () => handleFolderClick(searchResult) : onSelect;

    return (
      <div
        ref={(activeItem) => {
          this.activeItem = activeItem;
        }}
        className={`default-search-result ${activeClass}`}
        onClick={selectAction}
      >
        <div className="default-search-result--inner">
          <SearchResultContentWrapper>{this.renderItemDetails()}</SearchResultContentWrapper>
        </div>
        <div className="default-search-result--mask" />
      </div>
    );
  }

  renderItemDetails = () => {
    let { name, content, lastUpdatedBy, lastEditedByPosition, matchedTagContent, type, subType } = this.props;

    name = name && name.trim();
    // content looks like "Updated Jan 1 2021" for admin search results
    content = content && content.trim();
    lastUpdatedBy = lastUpdatedBy && lastUpdatedBy.trim();
    if (lastUpdatedBy) {
      if (lastEditedByPosition === 'below') {
        /*
          Content Title
          Updated Jan 1 2021
          Last edited by John Doe
        */
        /*
          Content Title
          Last edited by John Doe
        */
        content += `${content ? '<br />' : ''}Last edited by ${lastUpdatedBy}`;
      } else {
        /*
          Content Title
          Updated Jan 1 2021 by John Doe
        */
        /*
          Content Title
          Last edited by John Doe
        */
        content += (content ? ' by ' : 'Last edited by ') + lastUpdatedBy;
      }
    }

    const formattedContent = content ? (
      <div
        className="default-search-result--content"
        dangerouslySetInnerHTML={{ __html: sanitizeUserInput(content, { allowSafeTags: true }) }}
      />
    ) : undefined;

    return (
      <SearchResultDetails>
        {subType ? (
          <div style={{ width: '16px', height: '16px' }}>
            <ContentIcon type={type} subType={subType} size="md" />
          </div>
        ) : (
          <LearningObjectIcon type={type} iconClassName="default-search-result--icon" />
        )}
        <SearchResultDetailLabel className="default-search-result--label">
          <div>
            <div
              className="default-search-result--title"
              dangerouslySetInnerHTML={{ __html: sanitizeUserInput(name, { allowSafeTags: true }) }}
            />
            {formattedContent}
            {!_.isEmpty(matchedTagContent) && this.renderMatchedTags(matchedTagContent)}
          </div>
        </SearchResultDetailLabel>
      </SearchResultDetails>
    );
  };

  renderMatchedTags = (matchedTagContent) => (
    <MatchedTagWrapper className="default-search-result--content">
      <TagIcon src="/images/tag_solid_gray.svg" />
      <div dangerouslySetInnerHTML={{ __html: sanitizeUserInput(matchedTagContent, { allowSafeTags: true }) }} />
    </MatchedTagWrapper>
  );
}

const SearchResultContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const SearchResultDetails = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

const SearchResultDetailLabel = styled.div`
  padding-right: 0px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const MatchedTagWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const TagIcon = styled.img`
  height: 10px;
  width: 10px;
  margin-right: 3px;
`;
